import React, {
  useContext, useEffect, useState,
} from 'react';
import PropTypes from 'prop-types';
import {
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Alert,
  TableBody,
  Link,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { AppContext } from '../../../providers/authProvider';
import api from '../../../api/req';
import { catalogs, documents } from '../../../const/meta';
import Loader from '../../../components/MaterialUI/loader';
import { dateFormat } from '../../../api/utils';

function Contracts({ landId }) {
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [data, setData] = useState([]);
  const { auth } = useContext(AppContext);

  useEffect(
    () => {
      const loader = async () => {
        const r = await api.get(`${catalogs.lands.backend}${landId}/get_contracts`, auth);
        if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
        return r.json();
      };
      setLoading(true);
      setErr(null);
      loader()
        .then((d) => setData(d))
        .catch((e) => setErr(e.message))
        .finally(() => setLoading(false));
    },
    [auth, landId],
  );

  return (
    <TableContainer component={Paper} sx={{ height: '100%' }}>
      {err && (
        <Alert severity="error">
          {err}
        </Alert>
      )}
      {loading && (
      <Loader text="Завантаження" />
      )}
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell align="center">#</TableCell>
            <TableCell align="center">Платник</TableCell>
            <TableCell align="center">Договір</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, i) => (
            <TableRow key={row.date} hover>
              <TableCell align="right">{i + 1}</TableCell>
              <TableCell>
                <Link to={`${catalogs.payers.frontend}${row.payer.id}`} component={RouterLink}>
                  {row.payer.repr}
                </Link>
              </TableCell>
              <TableCell>
                <Link to={`${documents.contracts.frontend}${row.id}`} component={RouterLink}>
                  {row.number}
                  {' від '}
                  {dateFormat(row.date)}
                </Link>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

Contracts.propTypes = {
  landId: PropTypes.number.isRequired,
};

export default Contracts;
